import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getSoundcastSubscribers } from '../../../../helpers/soundcasts';
import Loading from '../../../../components/Loading';

const Subscribers = props => {
  const [subscribers, setSubscribers] = useState('');

  useEffect(() => {
    setTimeout(() => {
      const { soundcast } = props;
      getSoundcastSubscribers(soundcast, true).then(total => setSubscribers(`${total} subscribed`));
    }, 50);
  }, []);

  return (
    <React.Fragment>
      <span className="text-mediu">{subscribers || <Loading align="center" size={50} />}</span>
    </React.Fragment>
  );
};

Subscribers.propTypes = {
  soundcast: PropTypes.object,
};

Subscribers.defaultProps = {
  soundcast: {},
};

export default Subscribers;
